import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import { MessagePackHubProtocol } from "@microsoft/signalr-protocol-msgpack";
import { UseSignalrState } from "@/Helpers/UseSignalrState";

export interface UseBotProviderUserHubOptions {
    workspaceId?: string;
    botProviderId: string;
    userId: string;
    onHistoryUpdate?: (botProviderId: string, userId: string) => void;
}

export function useBotProviderUserHub({
    botProviderId,
    userId,
    onHistoryUpdate,
}: UseBotProviderUserHubOptions) {
    const { SetConnection, connectionState } = UseSignalrState();
    const onHistoryUpdateRef = useRef(onHistoryUpdate);
    onHistoryUpdateRef.current = onHistoryUpdate;

    useEffect(() => {
        if (!botProviderId || !userId) return;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/botProviderUserHub")
            .withHubProtocol(new MessagePackHubProtocol())
            .withAutomaticReconnect()
            .withStatefulReconnect()
            .build();

        SetConnection(connection);

        connection.on("OnHistoryUpdate", async (updatedBotProviderId: string, updatedUserId: string) => {
            onHistoryUpdateRef.current?.(updatedBotProviderId, updatedUserId);
        });

        connection
            .start()
            .then(async () => {
                console.log("SignalR Connected!");
                const success = await connection.invoke<boolean>("ListenEvent", botProviderId, userId);
                if (success) {
                    console.log("ListenEvent success");
                } else {
                    console.warn("ListenEvent fail");
                }
            })
            .catch((err) => {
                console.log("SignalR Connection Error: ", err);
            });

        return () => {
            if (connection) {
                connection
                    .stop()
                    .then(() => {
                        console.log("SignalR Disconnected!");
                    })
                    .catch((err) => {
                        console.log("SignalR Disconnection Error: ", err);
                    });
            }
        };
    }, [botProviderId, userId]);

    return { connectionState };
}
